import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {projectTitleInitialState} from '../reducers/project-title';
import updatetowebBlob from '../lib/updatetoweb-blob';
/**
 * Project saver component passes a downloadProject function to its child.
 * It expects this child to be a function with the signature
 *     function (downloadProject, props) {}
 * The component can then be used to attach project saving functionality
 * to any other component:
 *
 * <SB3UpdateToWeb>{(downloadProject, props) => (
 *     <MyCoolComponent
 *         onClick={downloadProject}
 *         {...props}
 *     />
 * )}</SB3UpdateToWeb>
 */
class SB3UpdateToWeb extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'downloadProject'
        ]);
    }
    downloadProject () {
        this.props.saveProjectSb3().then(content => {
            if (this.props.onSaveFinished) {
                this.props.onSaveFinished();
            }
            window.scratch.getProjectCover(dataURL => {
                    //TODO 获取到作品截图
                    console.log(cover)

                      var BASE64_MARKER = ';base64,';
                      var parts;
                      var contentType;
                      var raw;
                      if (dataURL.indexOf(BASE64_MARKER) === -1) {
                        parts = dataURL.split(',');
                        contentType = parts[0].split(':')[1];
                        raw = decodeURIComponent(parts[1]);
                        return new Blob([raw], {type: contentType});
                      }
                      parts = dataURL.split(BASE64_MARKER);
                      contentType = parts[0].split(':')[1];
                      raw = window.atob(parts[1]);
                      var rawLength = raw.length;
                      var uInt8Array = new Uint8Array(rawLength);
                      for (var i = 0; i < rawLength; ++i) {
                        uInt8Array[i] = raw.charCodeAt(i);
                      }
                      var cover = new Blob([uInt8Array], {type: contentType});
                      updatetowebBlob(this.props.projectFilename, content,cover,window.scratchConfig.userID,window.scratchConfig.filelists_local,window.scratchConfig.filelists_covers,window.scratchConfig.filelists_localsid);
            })
    
        });
    }
    render () {
        const {
            children
        } = this.props;
        return children(
            this.props.className,
            this.downloadProject
        );
    }
}

const getProjectFilename = (curTitle, defaultTitle) => {
    let filenameTitle = curTitle;
    if (!filenameTitle || filenameTitle.length === 0) {
        filenameTitle = defaultTitle;
    }
    return `${filenameTitle.substring(0, 100)}.sb3`;
};

SB3UpdateToWeb.propTypes = {
    children: PropTypes.func,
    className: PropTypes.string,
    onSaveFinished: PropTypes.func,
    projectFilename: PropTypes.string,
    saveProjectSb3: PropTypes.func
};
SB3UpdateToWeb.defaultProps = {
    className: ''
};

const mapStateToProps = state => ({
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
    projectFilename: getProjectFilename(state.scratchGui.projectTitle, projectTitleInitialState)
});

export default connect(
    mapStateToProps,
    () => ({}) // omit dispatch prop
)(SB3UpdateToWeb);
